import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { getFormatFecha } from "../../helpers/dates"
import PageController from "../pageController/PageController"
import './tbStyles.css'

export const TbVillages = ({ villages, updateVillage, deleteVillage }) => {

  const navigate = useNavigate();
  const [pueblos, setPueblos] = useState([])
  const [initData, setInitData] = useState(0)
  const pagesize = parseInt(process.env.REACT_APP_PAGE_RECORDS);

  useEffect(() => {
    const loadData = async () => {
      setPueblos(await villages.slice(initData, initData + pagesize));
    }
    loadData()
  }, [villages, initData, pagesize]);

  return (
    <div className="table-container">
      <table cellSpacing='0'>
        <thead>
          <tr>
            <th className="responsive-big">ID</th>
            <th>NOMBRE</th>
            <th >PROVINCIA</th>
            <th className="responsive-big" >UBICACION</th>
            <th className="responsive-movil">HORA</th>
            <th className="responsive">FECHA</th>
            <th className="responsive">FEC-OPEN</th>
            <th className="responsive">FEC-CLOSE</th>
            <th colSpan={3}>ACCIONES</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(pueblos)
            ? pueblos.map((village) => (
              <tr key={village.PUE_CLAVE}>
                <td className="responsive-big mulargo">{village.PUE_CLAVE}</td>
                <td>{village.PUE_NOMBRE}</td>
                <td >{village.PUE_PROVINCIA}</td>
                <td className="responsive-big">{village.PUE_UBICACION}</td>
                <td className="responsive-movil">{village.PUE_HORA}</td>
                <td className="responsive">{getFormatFecha(village.PUE_FECACT)}</td>
                <td className="responsive">{getFormatFecha(village.PUE_FECOPEN)}</td>
                <td className="responsive">{getFormatFecha(village.PUE_FECCLOSE)}</td>
                <td><button
                  onClick={() => updateVillage(village)}
                  className="material-icons-outlined">edit</button></td>
                <td><button
                  onClick={() => deleteVillage(village)}
                  className="material-icons-outlined">delete</button></td>
                <td><button
                  onClick={() => navigate("/codeqr/", {
                    state: { village }
                  })}
                  className="material-icons-outlined">qr_code</button></td>
              </tr>
            ))
            : <h1>NO HAY DATOS EN LA TABLA</h1>}
        </tbody>
      </table>
      <section className="tbFooter">
      <PageController initData={initData} setInitData={setInitData} length={villages.length}/>
      </section>
    </div>
  )
}
